import React from "react";
import { PROFILE } from "../data/content";
import { scrollToId } from "./shared";
import { OrbitRing, AstrolabeGlyph, PlanetDot } from "./motifs";

export default function Footer() {
  return (
    <footer className="relative bg-earthnight text-ivory/80 overflow-hidden">
      {/* orbit + constellation atmosphere */}
      <div className="pointer-events-none absolute -left-40 -top-40 opacity-40" aria-hidden>
        <div className="orbit-slow">
          <OrbitRing size={520} strokeOpacity={0.5} ticks />
        </div>
      </div>
      <div className="pointer-events-none absolute inset-0 constellation-grid opacity-20" aria-hidden />

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 pt-20 pb-10">
        {/* massive brand type */}
        <div className="border-b border-honey/15 pb-10 mb-10">
          <div className="flex items-center gap-3 mb-4">
            <AstrolabeGlyph size={16} color="#E0B84C" />
            <span className="font-mono-tech text-[10px] tracking-[0.32em] uppercase text-honey/80">
              Observatory · Sign-off
            </span>
          </div>
          <div
            className="headline-serif text-honey leading-[0.9]"
            style={{ fontSize: "clamp(3rem, 12vw, 10rem)" }}
          >
            Barbara <span className="italic">Betancourt</span>
          </div>
          <div className="mt-4 font-mono-tech text-xs tracking-[0.28em] uppercase text-honey/70">
            {PROFILE.title}
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-2 font-mono-tech text-[11px] tracking-widest uppercase text-honey/70">
            <PlanetDot /> {PROFILE.location} · Open to new roles
          </div>
          <div className="flex flex-wrap gap-6 font-mono-tech text-xs tracking-wide uppercase">
            <button onClick={() => scrollToId("about")} className="hover:text-honey transition-colors" data-testid="footer-about">About</button>
            <button onClick={() => scrollToId("experience")} className="hover:text-honey transition-colors" data-testid="footer-experience">Experience</button>
            <button onClick={() => scrollToId("portfolio")} className="hover:text-honey transition-colors" data-testid="footer-portfolio">Portfolio</button>
            <button onClick={() => scrollToId("contact")} className="hover:text-honey transition-colors" data-testid="footer-contact">Contact</button>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-honey/15 text-xs text-ivory/50 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} {PROFILE.name}. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
}
